/**
 * Practice Settings Page
 *
 * Page for managing organization settings including patient visibility
 * and templates configuration.
 * Part of the "Your Practice" feature.
 */

import { useEntitlement } from '@features/entitlements';
import { EPrescriptionOrgSection, JotRxSetupCallout } from '@features/eprescriptions';
import { OrgTemplatesSection } from '@features/templates/components';
import { Box, Typography } from '@mui/material';
import { hasAdminPrivileges } from '@utils/roleUtils';

import { OrganizationInfoCards } from './components/OrganizationInfoCards';
import { PatientVisibilitySection } from './components/PatientVisibilitySection';
import { useOrganizationAccess } from './store';

export default function PracticeSettingsPage() {
  const { organizationData, userState } = useOrganizationAccess();
  const { entitlement: jotrxEntitlement } = useEntitlement('jotrx');
  const isJotRxEnabled = !!jotrxEntitlement;
  const isOrgAdmin = hasAdminPrivileges(userState?.group_user_roles);

  return (
    <>
      {/* JotRx Setup Callout */}
      <JotRxSetupCallout page="practice-settings" userRoles={userState?.group_user_roles} />

      {/* Organization Info */}
      <OrganizationInfoCards
        organization={organizationData}
        activeMembers={[]}
        inactiveMembers={[]}
        variant="info"
      />

      {/* E-Prescription Settings (gated by jotrx entitlement) */}
      {isJotRxEnabled && (
        <Box id="eprescription-org-section" sx={{ mb: 3 }}>
          <EPrescriptionOrgSection />
        </Box>
      )}

      {/* Patient Visibility Settings */}
      <Box sx={{ mb: 3 }}>
        <PatientVisibilitySection />
      </Box>

      {/* Resources Section (only for org admins) */}
      {isOrgAdmin && (
        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ mb: 2 }}>
            Resources
          </Typography>
          <OrgTemplatesSection />
        </Box>
      )}
    </>
  );
}
